
























import {defineComponent, onMounted, PropType} from '@vue/composition-api'
import {useActions, useGetters} from 'vuex-composition-helpers'
import HttpService from "@/shared/services/http-service";
import GradesService from "../services/grades-service";
import ErrorMessagesComponent from "@/shared/components/ErrorMessages.vue";
import GradesComponent from './Grades.vue';
import LoaderComponent from '@/shared/components/Loader.vue';
import MessageComponent from '@/shared/components/Message.vue';
import { Config } from '@/apps/RecentGradesWidget/models/config-viewmodel'

export default defineComponent({
  name: 'RecentGradesComponent',
  components: {
    ErrorMessagesComponent,
    LoaderComponent,
    GradesComponent,
    MessageComponent
  },
  props: {
    configRaw: {
      type: Object as PropType<Config>,
      required: true
    }
  },
  setup: (props) => {
    let errors: string[] = []
    const { grades, loading, config } = useGetters(["grades", "loading", "config"])
    const { setGrades, setLoading, setConfig } = useActions(["setGrades", "setLoading", "setConfig"])

    onMounted(() => {
      startUp();
    })

    function startUp() {
      try {
        loadData();
        errors = [];
      } catch (error) {
        errors.push(getErrorText());
        setLoading(false);
      }
    }

    function loadData() {
      setConfig(props.configRaw);
      GradesService.getRecentGrades(config.value, HttpService)
          .then((grades) => {
            setGrades(grades);
          })
          .catch((error) => {
            console.error(error);
            errors.push(getErrorText());
          })
          .finally(() => setLoading( false));
    }

    function getErrorText(): string {
      return config.value.language.toLowerCase() === "nl"
          ? "Er gaat iets fout, probeer het later nog een keer"
          : "Something went wrong, please try again later";
    }

    return {errors, grades, loading, config, getErrorText}
  }
})
